import Menu from './Menu'
import RESOURCE_TYPE from './resource-type'
import globalAccess from './global-access'
import { i18nMerge, getMenuByRouter } from '../utils/assist'

function isUserAuth(v) {
    return !!v.uri || v.type == RESOURCE_TYPE.group
}

// 动态资源菜单
export default {
    namespaced: true,
    state: {
        // 资源菜单
        resTree: [],
        // 路由信息
        hasMenu: false,
        routes: [],
        flatRoutes: [],
        mapRoutes: {},
        namedRoutes: {},
        homeRoute: null,
        // 视图信息
        flatViews: [],
        mapViews: {},
        scopedViews: {},
        // 多语言文本
        message: { menu: {} },
    },
    getters: {
        // 动态菜单列表
        menuList: (state, getters, rootState) => {
            return getMenuByRouter(state.routes)
        },
        // 用户权限
        auth: state => state.resTree.filter(isUserAuth),
        // 获取当前路由的所有可见父级路由
        getRelativeRoutes: state => (route, namedRoutes) => {
            var homeName = Menu.options.homeName,
                homeItem,
                routeMatched = [route],
                namedRoutes = namedRoutes || state.namedRoutes,
                homeRoute = namedRoutes[homeName]

            if (homeRoute) {
                homeItem = {
                    icon: (homeRoute.meta && homeRoute.meta.icon) || '',
                    name: Menu.options.homeName,
                    meta: homeRoute.meta,
                }
            }

            var parent = namedRoutes[route.meta.parentName]

            while (parent) {
                routeMatched.unshift(parent)
                parent = namedRoutes[parent.meta.parentName]
            }

            if (homeRoute && routeMatched.some(item => item.name === homeName))
                return [homeItem]

            // bread-hide检查
            let list = routeMatched
                .filter(item => {
                    return (
                        (item.meta === undefined || !item.meta.hide) &&
                        item.meta.title
                    )
                })
                .map(item => {
                    let meta = { ...item.meta }

                    let obj = {
                        icon: (item.meta && item.meta.icon) || '',
                        name: item.meta.targetName || item.name,
                        meta: meta,
                    }

                    return obj
                })

            // ex: home / dir1 / dir2 / menu
            if (homeRoute) {
                list.unshift({ ...homeItem, to: { name: homeItem.name } })
            }

            return list
        },
    },
    mutations: {
        // 设置资源权限
        setRes(state, list) {
            state.resTree = list
        },
        // 清空资源
        clearRes(state) {
            state.resTree = []

            state.hasMenu = false
            //
            state.routes = []
            state.flatRoutes = []
            state.mapRoutes = {}
            state.namedRoutes = {}
            state.homeRoute = null
            //
            state.flatViews = []
            state.mapViews = {}
            state.scopedViews = {}
            //
            state.message = {}
        },
        // 设置动态路由(菜单)
        setMenu(state, { router, i18n, to }) {
            var resTree = state.resTree

            // 未加载资源
            if (!resTree || !resTree.length) {
                return
            }
            if (!router) {
                throw new Error('router is required')
            }

            // 解析资源
            var menu = Menu.create()
            menu.build(resTree)
            //// 动态主页
            if (Menu.options.homeName) {
                menu.setHomeRoute(Menu.options.homeName)
            }
            //// 绑定路由组件
            menu.updateRoutes(Menu.options.menuConfig)

            // 保存结果
            state.hasMenu = true
            // 路由
            state.routes = menu.routes
            state.flatRoutes = menu.flatRoutes
            state.mapRoutes = menu.mapRoutes
            state.namedRoutes = menu.namedRoutes
            state.homeRoute = menu.homeRoute
            // 视图
            state.flatViews = menu.flatViews
            state.mapViews = menu.mapViews
            state.scopedViews = menu.scopedViews
            // 翻译文本
            state.message = menu.message

            // 添加动态路由
            router.addRoutes(state.routes)

            // hack addRoutes
            // addRoutes会触发路由跳转。源码如下：
            // VueRouter.prototype.addRoutes = function addRoutes(routes) {
            //     this.matcher.addRoutes(routes);
            //     if (this.history.current !== START) {
            //         this.history.transitionTo(this.history.getCurrentLocation());
            //     }
            // }
            // 然而自vue-router@3.4.4(2020-9-24)之后，跳转会重置history.pending值，这会导致之前未执行完的队列提前中止。源码如下：
            // this$1就是router.history
            // if (this$1.pending !== route) {
            //     return abort(createNavigationCancelledError(current, route))
            // }
            // 也就是说，一旦调用addRoutes，那么本次navigation就会失败。不符合业务逻辑。所以只能强行将pending还原。
            // 另外新的跳转本身也会abort，因为它等于从from -> from，自身跳转到自身
            if (to) {
                router.history.pending = to
            }

            // 更新多语言库
            if (i18n) {
                i18n.setLocaleMessage(
                    'zh-CN',
                    i18nMerge(i18n.getLocaleMessage('zh-CN'), state.message)
                )
            }

            // 更新权限库
            globalAccess.setAuth(resTree.filter(isUserAuth))
        },
    },
}
